import { render, staticRenderFns } from "./ReadOnlyFields.vue?vue&type=template&id=47f29ef8&"
import script from "./ReadOnlyFields.vue?vue&type=script&lang=ts&"
export * from "./ReadOnlyFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports